import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { normalizeLedgerUsername } from '../lib/daisySeal';

export function useAuthorizedUsernames() {
  const { data: authorizedUsernames = [], ...rest } = useQuery({
    queryKey: ['authorizedUsernames'],
    staleTime: 300000,
    refetchOnWindowFocus: false,
    queryFn: async (): Promise<string[]> => {
      const res = await fetch('/api/authorized-usernames');
      if (!res.ok) return [];
      const data = await res.json();
      return Array.isArray(data.usernames) ? data.usernames : [];
    },
  });

  const authorizedUsers = useMemo(
    () => new Set(authorizedUsernames.map((name) => normalizeLedgerUsername(name))),
    [authorizedUsernames],
  );

  return { authorizedUsernames, authorizedUsers, ...rest };
}
